import { OrganizationLogo } from "@/components/organization";

import { OrganizationSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemDescription, SearchItemLabel } from "../SearchItemLabel";

export type OrganizationSearchItemViewProps = {
  item: OrganizationSearchItem;
};

export const OrganizationSearchItemView = ({ item }: OrganizationSearchItemViewProps) => {
  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-4 flex-2 min-w-0">
        <OrganizationLogo organization={item.organization} height={30} width={30} />
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{item.organization.name}</SearchItemLabel>
          {item.organization.abbreviation && (
            <SearchItemDescription>{item.organization.abbreviation}</SearchItemDescription>
          )}
        </div>
      </div>
      <div className="flex items-center shrink-0">
        <GlobalSearchItemTypeChip type="organization" />
      </div>
    </div>
  );
};
